import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.ensureSession().then((hasSession) => {
    if (hasSession) {
      return true;
    }
    return router.createUrlTree(['/auth/login']);
  });
};
